import {UserAttribute} from './user-attribute.model';
import {Publisher} from '../publisher.model';
import {DemandPartner} from '../demand-partner.model';
import {UserType} from './user-type.model';
import {UserRole} from '../../auth/rbac/user-role.enum';
import {UserUtils} from './user-utils.model';
export class User {

  id: number;
  name: string;
  email: string;
  password: string;
  roles: string[];
  rights: string[];
  accessToken: string;
  username: string;
  companyId: string;
  publisherId: string;
  demandPartnerId: string;
  createdOn: string;
  lastLoginTime: string;
  enabled: boolean;

  attributes: UserAttribute[];

  publisher: Publisher;
  demandPartner: DemandPartner;

  _type: UserType;
  _roles: UserRole[] = [];
  _property: string;

}

export class UserAttributes {
  public static PUBLISHER_ID = 'publisherId';
  public static DEMAND_PARTNER_ID = 'demandPartnerId';
}


